import React from 'react';
import { Globe, Linkedin } from 'lucide-react';
import { getCompanyLogoUrl } from '../../utils/brandfetch';
interface TechnicalCoachCardProps {
  name: string;
  role: string;
  image: string;
  title?: string;
  company?: string;
  companyDomain?: string;
  bio?: string;
  specialties?: string[];
  linkedin?: string;
  website?: string;
}
export const TechnicalCoachCard = ({
  name,
  role,
  image,
  title,
  company,
  companyDomain,
  bio,
  specialties,
  linkedin,
  website
}: TechnicalCoachCardProps) => {
  const logoUrl = getCompanyLogoUrl(companyDomain);
  return <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm transition-colors duration-300 hover:bg-white/[0.08]" data-id="element-366" data-mp="233ckrq3s7oqz">
      {/* Portrait */}
      <div className="relative aspect-[4/3] w-full overflow-hidden" data-id="element-367" data-mp="3jjyul7czq5zm">
        <img src={image} alt={name} className="h-full w-full object-cover object-top" loading="lazy" data-id="element-368" data-mp="3jkqkq2ntjbii" />
        <div className="absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-[#1a0d24]/70 to-transparent" aria-hidden="true" data-id="element-369" data-mp="3tjryl6qutlbj" />

        {(linkedin || website) && <div className="absolute right-2.5 top-2.5 flex gap-1.5" data-id="element-370" data-mp="75ieh9tyizgk">
            {linkedin && <a href={linkedin} target="_blank" rel="noopener noreferrer" aria-label={`${name} on LinkedIn`} className="rounded-md bg-black/40 p-1.5 text-white/70 backdrop-blur-sm transition-colors hover:text-white" data-id="element-371" data-mp="25dwffdehwo8">
                <Linkedin size={16} data-id="element-372" data-mp="3kkwqtq85w364" />
              </a>}
            {website && <a href={website} target="_blank" rel="noopener noreferrer" aria-label={`${name}'s website`} className="rounded-md bg-black/40 p-1.5 text-white/70 backdrop-blur-sm transition-colors hover:text-white" data-id="element-373" data-mp="3fjqxpraladw2">
                <Globe size={16} data-id="element-374" data-mp="12uhabshryypv" />
              </a>}
          </div>}
      </div>

      {/* Detail panel */}
      <div className="flex flex-1 flex-col p-5" data-id="element-375" data-mp="16yxftsnh844k">
        <h3 className="font-outfit text-xl font-bold leading-tight text-white" data-id="element-376" data-mp="1bvnucbjmurnv">
          {name}
        </h3>

        {(company || title) && <div className="mt-3 flex items-center gap-3" data-id="element-377" data-mp="1gu8ts8r297b9">
            {logoUrl && <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-white p-1.5" data-id="element-378" data-mp="j8urnnmonib8">
                <img src={logoUrl} alt={`${company} logo`} className="h-full w-full object-contain" loading="lazy" data-id="element-379" data-mp="o6ml4m2z7chj" />
              </span>}
            <div className="min-w-0 font-manrope" data-id="element-380" data-mp="h20lyr6c765">
              {company && <p className="truncate text-base font-semibold leading-snug text-white" data-id="element-381" data-mp="5fvc5lmwho3o">
                  {company}
                </p>}
              {title && <p className="text-sm leading-snug text-white/60" data-id="element-382" data-mp="3tznnsmyby5wn">{title}</p>}
            </div>
          </div>}

        <p className="mt-4 border-t border-white/10 pt-4 font-manrope text-sm font-medium uppercase tracking-wider text-white/45" data-id="element-383" data-mp="3k3al4zkt4hpr">
          {role}
        </p>

        {bio && <p className="mt-2 font-manrope text-sm leading-relaxed text-white/70" data-id="element-384" data-mp="3f6tzcc12yffu">
            {bio}
          </p>}

        {specialties && specialties.length > 0 && <div className="mt-auto flex flex-wrap gap-2 pt-4" data-id="element-385" data-mp="36aulm8r471tl">
            {specialties.map(specialty => <span key={specialty} className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-sm text-white/70" data-id="element-386" data-mp="31aq6am1y0d4y">
                {specialty}
              </span>)}
          </div>}
      </div>
    </article>;
};